import { cleanString } from 'helpers/RouteHelper';

export const isTabActive = (pathName = '', headline = '') =>
  pathName.includes(`/find/${headline}`.toLowerCase());

export const getDropdownName = (pathName = '') => {
  const [, newPathName] = pathName.split('/filter/');
  return cleanString(decodeURI(newPathName));
};

export const isDropdownActive = (pathName = '', headline = '') =>
  pathName.includes(`/find/${headline}/filter`.toLowerCase());
